/* eslint-disable react/prop-types */
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import classes from "./cumulative-announcements.module.scss";
import CorrelatedAnnouncementList from "@/composed-views/correlated-announcement-list";
function CumulativeAnnoucements({
  correlatedAnnouncements,
  sectors,
  admin,
  offer,
}) {
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classes.container}
    >
      <Label
        tag="h3"
        weight="bold"
        color="secondary"
        align="start"
        className={classes.title}
      >
        Completa l’offerta selezionando i bandi cumulabili
      </Label>
      <Label tag="p" color="secondary" align="start" size="md">
        Seleziona i bandi che vuoi aggiungere per completare la tua offerta
        personalizzata. Ogni bando correlato ha una scadenza di cumulabilità,
        sarà quindi disponibile all’interno del tuo pacchetto personalizzato
        solo se l’offerta sarà finalizzata entro quella data.
      </Label>
      <Label tag="p" color="secondary" align="start" size="md" weight="bold">
        Per cumulabilità si intende la possibilità di utilizzare più
        agevolazioni differenti per coprire le stesse spese del medesimo
        investimento/progetto
      </Label>

      <Flex
        align={isMobile ? "center" : "flex-start"}
        direction={isMobile ? "column" : "row"}
        justify={isMobile ? "center" : "flex-start"}
        className={classes.sectorsContainer}
      >
        <Label tag="p" color="secondary" align="start" size="md" weight="bold">
          Settori di investimento:
        </Label>
        <Label tag="p" color="secondary" align="start" size="md">
          {sectors}
        </Label>
      </Flex>
      <CorrelatedAnnouncementList
        announcements={correlatedAnnouncements}
        admin={admin}
        fromCorrelatedAnnouncementes={true}
        className={classes.list}
        offer={offer}
      />
    </Flex>
  );
}

export default CumulativeAnnoucements;
